"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNITY_LOADERS_CUSTOM_BUILD = exports.UNITY_LOADERS_WITH_DATA_SAVE = exports.UNITY_GAME_LOADERS = exports.LOADERS_WITH_SITELOCK = exports.UNITY_LOADER_2020 = exports.UNITY_LOADER_56 = exports.UNITY_LOADER_54 = exports.AVAILABLE_DEVELOPER_LOADER_TYPES = exports.NON_RECOMMENDED_LOADER_TYPES = exports.RECOMMENDED_LOADER_TYPES = exports.LOADERS_WITH_HTML5_FALLBACK = exports.LIMITED_ADMIN_UPDATE_OPTIONS = exports.ALL_LOADER_TYPES = void 0;
exports.gameLoaderTypeToName = gameLoaderTypeToName;
exports.ALL_LOADER_TYPES = [
    'iframe',
    'html5',
    'external',
    'ruffle',
    'flash', // deprecated, at some point we will remove it as all games are archived
    'fake',
    'error',
    // unity loaders
    'unity6',
    'unity2023',
    'unity2022',
    'unity2021',
    'unity2020',
    'unity2019',
    'unity2018',
    'unity2017',
    '5.6.x', // we used to store Unity 2017, 2018 and 2019 as 5.6.x also, so in the database there may be some 5.6.x games that are not Unity 5.6.x
    '5.4.x',
    // loaders with fallback to HTML5
    'godot',
    'defold',
    'gamemaker',
    'gdevelop',
    'cocos',
    'playcanvas',
    'unreal',
    'construct',
    'layaair',
];
/**
 * These are old games and we don't support fully updating them anymore. There is limited support for updating flags like mobile friendly.
 */
exports.LIMITED_ADMIN_UPDATE_OPTIONS = ['external', 'ruffle', 'flash'];
exports.LOADERS_WITH_HTML5_FALLBACK = [
    'godot',
    'defold',
    'gamemaker',
    'gdevelop',
    'cocos',
    'playcanvas',
    'unreal',
    'construct',
    'layaair',
];
/**
 * Developers can select any one of these types when creating a submission.
 * However, we prefer that developers use recent Unity versions, so hide older Unity versions behind a "show more" button
 */
exports.RECOMMENDED_LOADER_TYPES = [
    'html5',
    'unity6',
    'unity2022',
    'godot',
    'defold',
    'gamemaker',
    'gdevelop',
    'cocos',
    'playcanvas',
    'unreal',
    'construct',
    'layaair',
    'iframe',
];
/** These will be displayed when developers click the "Show More" button in the loader dropdown. */
exports.NON_RECOMMENDED_LOADER_TYPES = [
    'unity2023',
    'unity2021',
    'unity2020',
    'unity2019',
    'unity2018',
    'unity2017',
    '5.6.x',
];
exports.AVAILABLE_DEVELOPER_LOADER_TYPES = [...exports.RECOMMENDED_LOADER_TYPES, ...exports.NON_RECOMMENDED_LOADER_TYPES];
exports.UNITY_LOADER_54 = ['5.4.x'];
exports.UNITY_LOADER_56 = ['5.6.x', 'unity2017', 'unity2018', 'unity2019'];
exports.UNITY_LOADER_2020 = ['unity2020', 'unity2021', 'unity2022', 'unity2023', 'unity6'];
/**
 * These Unity versions benefit from the sitelock.
 * Keep DP and Graph in sync.
 */
exports.LOADERS_WITH_SITELOCK = [
    'unity6',
    'unity2023',
    'unity2022',
    'unity2021',
    'unity2020',
    'unity2019',
    'unity2018',
    'unity2017',
    '5.6.x',
];
exports.UNITY_GAME_LOADERS = [
    'unity6',
    'unity2023',
    'unity2022',
    'unity2021',
    'unity2020',
    'unity2019',
    'unity2018',
    'unity2017',
    '5.6.x',
    '5.4.x',
];
/**
 * These game loader versions display the toggles so the dev can tell us how the game saves data,
 * and also allow displaying a custom file name field, for when the game stores data in file.
 * Keep in sync DP and Graph.
 */
exports.UNITY_LOADERS_WITH_DATA_SAVE = [
    'unity6',
    'unity2023',
    'unity2022',
    'unity2021',
    'unity2020',
    'unity2019',
    'unity2018',
    'unity2017',
    '5.6.x',
];
function gameLoaderTypeToName(gameLoaderType) {
    switch (gameLoaderType) {
        case 'unity6':
            return 'Unity 6';
        case 'unity2023':
            return 'Unity 2023';
        case 'unity2022':
            return 'Unity 2022';
        case 'unity2021':
            return 'Unity 2021';
        case 'unity2020':
            return 'Unity 2020';
        case 'unity2019':
            return 'Unity 2019';
        case 'unity2018':
            return 'Unity 2018';
        case 'unity2017':
            return 'Unity 2017';
        case '5.6.x':
            return 'Unity 5.6';
        case 'iframe':
            return 'Externally hosted (iframe)';
        case 'html5':
            return 'HTML5';
        case 'godot':
            return 'Godot';
        case 'defold':
            return 'Defold';
        case 'gamemaker':
            return 'GameMaker';
        case 'gdevelop':
            return 'GDevelop';
        case 'cocos':
            return 'Cocos';
        case 'playcanvas':
            return 'PlayCanvas';
        case 'unreal':
            return 'Unreal';
        case 'construct':
            return 'Construct';
        case 'layaair':
            return 'LayaAir';
        case 'external':
            return 'External';
        case '5.4.x':
            return 'Unity 5.4';
        case 'flash':
            return 'Flash';
        case 'ruffle':
            return 'Ruffle';
        case 'fake':
            return 'Fake';
        case 'error':
            return 'Error';
        default:
            throw new Error(`Unmapped loader type: ${gameLoaderType}`);
    }
}
/** Unity loaders that support custom build script from the SDK. */
exports.UNITY_LOADERS_CUSTOM_BUILD = ['unity6'];
